import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { Reveal, LineReveal } from "@/components/Reveal";

export default function DetailPage({ type }) {
  const { id } = useParams();
  const { policies, beliefs, loading } = useContent();
  const items = type === "policy" ? policies : beliefs;
  const backTo = type === "policy" ? "/policy" : "/beliefs";
  const item = items.find((x) => x.id === id);

  if (loading && !item) {
    return (
      <div className="flex min-h-screen items-center justify-center text-bone/50">
        <span className="animate-pulse font-display text-2xl">Loading…</span>
      </div>
    );
  }
  if (!item) return <Navigate to={backTo} replace />;

  const fullText = (item.detail && item.detail.trim()) ? item.detail : item.body;

  return (
    <div data-testid={`${type}-detail-page`}>
      <section className="border-b border-hairline/50 pt-40 pb-20 md:pt-52 md:pb-28">
        <div className="mx-auto max-w-[1100px] px-5 md:px-10">
          <Link
            to={backTo}
            data-testid="detail-back-link"
            className="link-underline inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-bone/50 hover:text-bone"
          >
            <ArrowLeft size={15} /> Back to {type === "policy" ? "Policy" : "Beliefs"}
          </Link>

          <div className="mt-8 text-xs uppercase tracking-[0.32em] text-kinetic">
            {type === "policy" ? "Policy Statement" : `Belief ${item.number || ""}`}
          </div>
          <h1 className="mt-5 max-w-3xl font-display text-5xl font-bold leading-[0.95] tracking-tighter text-bone md:text-7xl">
            <LineReveal text={item.title || ""} />
          </h1>
          {type === "policy" && item.summary && (
            <Reveal delay={0.35} className="mt-7 max-w-2xl text-lg text-kinetic/90">
              <p>{item.summary}</p>
            </Reveal>
          )}
        </div>
      </section>

      <section className="mx-auto max-w-[1100px] px-5 py-20 md:px-10 md:py-28">
        <Reveal>
          <div className="max-w-3xl whitespace-pre-line text-lg leading-relaxed text-bone/75 md:text-xl">
            {fullText}
          </div>
        </Reveal>
      </section>
    </div>
  );
}
